import {Button, Modal} from "react-bootstrap";
import {useEffect, useState} from "react";
import client, {baseURL} from "../../../../../axios";

interface UploadExcelProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  afterUpload: () => void;
}

export default function UploadExcel(props: UploadExcelProps) {

  const [file, setFile] = useState<File | null>(null);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);

  const [uploading, setUploading] = useState(false);

  const [progress, setProgress] = useState(0);

  function handleOpenConfirm() {
    if (file) {
      setOpenConfirm(true);
    }
  }

  async function handleSaveData() {
    setOpenConfirm(false);
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file as File);

      const response = await fetch(`${baseURL}/api/standard-info/excel`, {
        method: "POST",
        body: formData,
        credentials: "include",
      });
      const reader = response.body?.getReader();
      const decoder = new TextDecoder('utf-8');

      if (reader) {
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            reader.releaseLock();
            break;
          }

          const chunk = decoder.decode(value);
          const lines = chunk.trim().split("\n");

          lines.forEach((line) => {
            if (line.startsWith("data:")) {
              const {progress} = JSON.parse(line.slice(5));
              setProgress(Math.round(progress * 100));
            }
          });
        }

        setSuccess(true);
        props.afterUpload();
      } else {
        throw new Error("Failed to upload data");
      }
    } catch (e) {
      console.error(e);
      setFailed(true)
    } finally {
      setUploading(false);
    }
  }

  function handleCloseSuccess() {
    props.setOpen(false);
    setSuccess(false);
    setFile(null);
  }

  function handleCloseFailed() {
    setFailed(false);
  }

  return (
    <>
      <Modal show={props.open} onHide={() => props.setOpen(false)} centered>
        <Modal.Header closeButton>
          엑셀 업로드
        </Modal.Header>
        <Modal.Body>
          <p>파일 선택</p>
          <input
            type="file"
            className='form-control'
            accept=".xls,.xlsx"
            onChange={e => setFile(e.target.files![0])}
          />
          <div className='my-3' />
          <progress value={progress} max="100" style={{ width: '100%' }} />
          <div className='my-3' />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => props.setOpen(false)} disabled={uploading}>
            취소
          </Button>
          <Button variant='primary' onClick={handleOpenConfirm} disabled={uploading}>
            {uploading ? '업로드 중...' : '업로드'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openConfirm} centered>
        <Modal.Body>
          선택하신 파일을 업로드 하시겠습니까?
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setOpenConfirm(false)}>
            취소
          </Button>
          <Button variant='primary' onClick={handleSaveData}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={success} centered>
        <Modal.Body>
          업로드에 성공하였습니다.
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleCloseSuccess}>
            닫기
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={failed} centered>
        <Modal.Body>
          업로드에 실패하였습니다.
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleCloseFailed}>
            닫기
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}